import { render, staticRenderFns } from "./NoticeRemoveLawyerChild.vue?vue&type=template&id=9cf3be1e"
import script from "./NoticeRemoveLawyerChild.vue?vue&type=script&lang=ts"
export * from "./NoticeRemoveLawyerChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports